class SearchPatientAnalysis{
    constructor() {
        this.patientId = undefined;
        this.userId = undefined;
        this.name = undefined;
        this.sessionsCount = undefined;
        this.appointmentSessionsCount = undefined;
        this.admittedSessionsCount = undefined;
        this.exceptionCount = undefined;
        this.sortBy = undefined;
        this.sortOrder = undefined;
        this.pagingParams = {
            pageNumber: undefined,
            pageSize: undefined
        }
    }
}
export default SearchPatientAnalysis;